// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CombinationSvg from '@rsuite/icon-font/lib/action/Combination';
var Combination = createSvgIcon({
  as: CombinationSvg,
  ariaLabel: 'combination',
  category: 'action',
  displayName: 'Combination'
});
export default Combination;